import React from 'react';
import PropTypes from 'prop-types';
import './patientPrescription.scss';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import dateOrDash from 'App/utils/dateOrDash';
import pathOrDash from 'App/utils/pathOrDash';
import { Button } from 'react-bootstrap';
import { rxPropType } from 'Shared/types';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import getFeatureFlagStatus from 'App/utils/getFeatureFlagStatus';

const propTypes = {
    prescription: rxPropType.isRequired,
    viewProfile: PropTypes.bool,
    handleViewRxNotes: PropTypes.func,
    handleAddRxNotes: PropTypes.func,
};

const defaultProps = {
    viewProfile: false,
    handleViewRxNotes: () => {},
    handleAddRxNotes: () => {},
};

function RxFillNumberView({ prescription, viewProfile, handleViewRxNotes, handleAddRxNotes }) {
    const { physician, rxFill } = prescription;
    const isCodifiedMedicationsEnabled = getFeatureFlagStatus(PERMISSION_TYPES.ENABLE_CODIFY_MEDICATIONS);

    return (
        <div className="view-rx-fill-container">
            <div>
                {isCodifiedMedicationsEnabled && (
                    <div className="block-section">
                        <Row>
                            <Col md={4}>Product Description</Col>
                            <Col md={2}>Product NDC</Col>
                            <Col md={2}>Dispensed Pharmacy</Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <strong>{pathOrDash(['dispensedMedication'], prescription)}</strong>
                            </Col>
                            <Col md={2}>
                                <strong>{pathOrDash(['ndc'], prescription)}</strong>
                            </Col>
                            <Col md={2}>
                                <strong>{pathOrDash(['dispensedPharmacy'], prescription)}</strong>
                            </Col>
                        </Row>
                    </div>
                )}

                <div className="block-section">
                    <Row>
                        <Col md={2}>Rx Number</Col>
                        <Col md={2}>Rx Strength</Col>
                        <Col md={2}>Refills Allowed</Col>
                        <Col md={2}>Prescriber</Col>

                        {viewProfile ? (
                            <>
                                <Col md={2}>Rx Status</Col>
                                <Col md={2}>Notes</Col>
                            </>
                        ) : null}
                    </Row>
                    <Row>
                        <Col md={2}>
                            <strong>{pathOrDash(['rxNumber'], prescription)}</strong>
                        </Col>
                        <Col md={2}>
                            <strong>{pathOrDash(['strength'], prescription)}</strong>
                        </Col>
                        <Col md={2}>
                            <strong>{pathOrDash(['refillsAuthorized'], prescription)}</strong>
                        </Col>
                        <Col md={2}>
                            <strong>
                                {physician?.firstName ? `${physician?.firstName} ${physician?.lastName}` : '--'}
                            </strong>
                        </Col>
                        {viewProfile ? (
                            <>
                                <Col md={2}>
                                    {prescription?.prescriptionData?.data?.RxStatus ? (
                                        <strong>
                                            {pathOrDash(['RxStatus'], prescription?.prescriptionData?.data)}
                                        </strong>
                                    ) : (
                                        <strong>
                                            {pathOrDash(
                                                ['RxStatus'],
                                                prescription?.prescriptionData?.data?.Prescription
                                            )}
                                        </strong>
                                    )}
                                </Col>
                                <Col md={2}>
                                    <div className="notes-button">
                                        <Button
                                            variant="link"
                                            className="btn btn-link btn-default custom-button-left"
                                            onClick={handleViewRxNotes}
                                        >
                                            View{' '}
                                        </Button>{' '}
                                        |
                                        <Button
                                            variant="link"
                                            className="btn btn-link btn-default custom-button-left"
                                            onClick={handleAddRxNotes}
                                        >
                                            {' '}
                                            Add
                                        </Button>
                                    </div>
                                </Col>
                            </>
                        ) : null}
                    </Row>
                </div>

                <div className="block-section">
                    <Row className="seven-cols">
                        <Col md={2}>Rx Written Date</Col>
                        <Col md={2}>Rx Exp. Date</Col>
                        <Col md={2}>Rx End Date</Col>
                        {viewProfile ? <Col md={2}>End Reason</Col> : null}
                    </Row>
                    <Row>
                        <Col md={2}>
                            <strong>{dateOrDash(['start'], prescription)}</strong>
                        </Col>
                        <Col md={2}>
                            <strong>{dateOrDash(['fillExpiration'], prescription)}</strong>
                        </Col>
                        <Col md={2}>
                            <strong>{dateOrDash(['end'], prescription)}</strong>
                        </Col>
                        {viewProfile ? (
                            <Col md={2}>
                                <strong>{pathOrDash(['endReason'], prescription)}</strong>
                            </Col>
                        ) : null}
                    </Row>
                </div>
            </div>
            <div>
                {rxFill?.length > 0 ? (
                    <div className="view-rx-fill-container">
                        <div className="block-section">
                            <Row>
                                <Col md={3}>Fill Number</Col>
                                <Col md={3}>Fill Date</Col>
                                <Col md={3}>Dispensed Qty</Col>
                                <Col md={3}>Days Supply</Col>
                            </Row>

                            {rxFill.map((fill, index) => (
                                // TODO: Fix this the next time the file is edited.
                                // eslint-disable-next-line react/no-array-index-key
                                <Row key={index}>
                                    <Col md={3}>
                                        {fill?.fillNumber === 0 ? (
                                            <strong>{fill.fillNumber}</strong>
                                        ) : (
                                            <strong>{pathOrDash(['fillNumber'], fill)}</strong>
                                        )}
                                    </Col>
                                    <Col md={3}>
                                        <strong>{dateOrDash(['fillDate'], fill)}</strong>
                                    </Col>
                                    <Col md={3}>
                                        <strong>{pathOrDash(['dispensedQuantity'], fill)}</strong>
                                    </Col>
                                    <Col md={3}>
                                        <strong>{pathOrDash(['daysSupply'], fill)}</strong>
                                    </Col>
                                </Row>
                            ))}
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

RxFillNumberView.propTypes = propTypes;
RxFillNumberView.defaultProps = defaultProps;

export default RxFillNumberView;
